import { Decorator, getIn } from 'final-form'
import createDecorator, { FocusableInput } from 'final-form-focus'
import scrollIntoView from 'scroll-into-view'

interface IFinalFormErrors {
  [key: string]: string | IFinalFormErrors
}

type ControlElement = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | HTMLButtonElement

/** Название dom-атрибута для поиска инпутов */
const DATA_FIELD_NAME_ATTRIBUTE = 'data-field-name'

const TAG_NAME_ELEMENTS_WITHOUT_FOCUS = ['DIV']

const isFocusable = (element?: HTMLElement) => typeof element?.focus === 'function'

const getInputName = (element: ControlElement | HTMLElement) =>
  ('name' in element && element.name) || element.getAttribute(DATA_FIELD_NAME_ATTRIBUTE)

const getFirstErrorInput = (elements: HTMLElement[], errors: IFinalFormErrors) => {
  if (elements.length === 0) {
    return
  }

  let topInput: HTMLElement | undefined
  let topInputOffset: number | null = null

  elements.forEach((element) => {
    const name = getInputName(element)

    if (!name || !getIn(errors, name)) {
      return
    }

    const elementTopOffset = element.getBoundingClientRect().top
    // элемент, родитель которого имеет display:none, присутствует на странице, но не имеет размеров
    const isElementVisible = Boolean(element.offsetWidth || element.offsetHeight)

    if ((topInputOffset === null || elementTopOffset < topInputOffset) && isElementVisible) {
      topInput = element
      topInputOffset = elementTopOffset
    }
  })

  if (topInput && TAG_NAME_ELEMENTS_WITHOUT_FOCUS.includes(topInput.tagName)) {
    topInput.focus = new Proxy(topInput.focus, {
      apply(_, element) {
        const inModal = element.closest('.z-modal')
        if (!inModal) {
          scrollIntoView(element, { time: 0 })
        }
      }
    })
  }

  return topInput
}

const createGetInputs = (name?: string) => () => {
  if (typeof document === 'undefined') {
    return []
  }

  //  @ts-expect-error
  const form: HTMLFormElement | null = (name && document.forms[name]) || null

  if (!form) {
    return []
  }

  const fields: { [key: string]: FocusableInput } = {}

  form.querySelectorAll<ControlElement | HTMLElement>(`[name], [${DATA_FIELD_NAME_ATTRIBUTE}]`).forEach((element) => {
    const name = getInputName(element)

    if (!name || fields[name] || !isFocusable(element)) {
      return
    }

    fields[name] = element as FocusableInput
  })

  return Object.values(fields)
}

export const createScrollToErrorDecorator = <FormValues, InitialFormValues = Partial<FormValues>>(name?: string) =>
  // @ts-ignore
  createDecorator(createGetInputs(name), getFirstErrorInput) as Decorator<FormValues, InitialFormValues> // eslint-disable-line
